import BaseObject from '../../base/base_object';
import Device from '../../utils/device/device';

export default class InitObjectBuilder extends  BaseObject {
    static CLASS = 'InitObjectBuilder';

    init(params) {
        this.serviceFactory = params.serviceFactory;
        this._enableCaptcha = params.enableCaptcha;
    }

    buildInitObject() {
        return {
            subbrandid: this.serviceFactory.skinService().getSubBrandID(),
            productpackageid: this.serviceFactory.skinService().getProductPackageID(),
            languagecode: this.serviceFactory.languageService().getISO3(),
            formoptions: this.buildFormOptions(),
            showclosebutton: true,
            logoptions: {
                disabletrackjs: true
            },
            appSwitch: {
                switchbackurl: this._getSwitchBackSmartLink(),
                switchbackos: this._getSwitchBackOs()
            }
            //containerselector: '.cgp-web-login-wrapper'
        };
    }

    buildFormOptions() {
        return {
            mode: {
                type: 'pwd',
                errorcodeid: 0,
                modeoptions: {
                    username: this._getLastLoginUserName(),
                    showrememberme: !Device.os.isMobileOS
                }
            },
            enablecaptcha: this._enableCaptcha
        };
    }

    _getLastLoginUserName() {
        let userData = this.serviceFactory.oAuth2Service().getUserData();
        if(userData && userData.userName) {
            return userData.userName;
        }

        return null;
    }

    _getSwitchBackOs() {
        if(Device.os.isIOS) {
            return 'ios';
        }else if(Device.os.isAndroid) {
            return 'android';
        }

        return '';
    }

    _getSwitchBackSmartLink() {
        let url = this.serviceFactory.windowService().getLocationOrigin();
        if(Device.hybrid.isHybrid) {
            url = this.serviceFactory.hybridService().getSwitchBackSmartLinkToOpen()
        }

        return url;
    }
}
